/** 客服表情库 index，与 TIM createFaceMessage payload.index 对应 */
export const CS_EMOJI_PACK_INDEX = 1;
/** 表情包数量 emoji_0.png ~ emoji_61.png */
export const EMOJI_COUNT = 62;
function emojiFile(index) {
    return `emoji_${index}.png`;
}
export const CS_EMOJIS = Array.from({ length: EMOJI_COUNT }, (_, index) => ({
    data: `emoji_${index}`,
    file: emojiFile(index),
    imageUrl: `/emoji/${emojiFile(index)}`,
    label: `表情${index + 1}`,
}));
const emojiMap = new Map(CS_EMOJIS.map((item) => [item.data, item]));
function toFaceText(data) {
    if (data == null)
        return '';
    if (typeof data === 'string')
        return data.trim();
    if (typeof data === 'number' || typeof data === 'boolean')
        return String(data);
    return '';
}
export function getEmojiImageUrl(data) {
    if (!data)
        return '';
    let key = data.trim();
    const bracketMatch = /^\[(emoji_\d+)\]$/.exec(key);
    if (bracketMatch)
        key = bracketMatch[1];
    if (!key.startsWith('emoji_'))
        key = `emoji_${key}`;
    const item = emojiMap.get(key);
    if (item)
        return item.imageUrl;
    const match = /^emoji_(\d+)$/.exec(key);
    if (!match)
        return '';
    const index = Number(match[1]);
    if (Number.isNaN(index) || index < 0 || index >= EMOJI_COUNT)
        return '';
    return `/emoji/${emojiFile(index)}`;
}
/** 文本中表情包占位符：[emoji_0] */
export const EMOJI_TOKEN_RE = /\[emoji_\d+\]/g;
export function formatEmojiToken(data) {
    const key = data.startsWith('emoji_') ? data : `emoji_${data}`;
    return `[${key}]`;
}
function extractEmojiKey(token) {
    const bracketMatch = /^\[(emoji_\d+)\]$/.exec(token);
    if (bracketMatch)
        return bracketMatch[1];
    if (/^emoji_\d+$/.test(token))
        return token;
    return token;
}
export function resolveFaceDisplay(index, data) {
    const text = toFaceText(data);
    const imageUrl = getEmojiImageUrl(text);
    if (imageUrl) {
        const item = emojiMap.get(text.startsWith('emoji_') ? text : `emoji_${text}`);
        return { imageUrl, label: item?.label ?? '表情' };
    }
    if (index == null || !text)
        return { imageUrl: '', label: '表情' };
    return { imageUrl: '', label: '表情' };
}
/** 兼容旧版 emoji_0（非 [emoji_0]）；不用 (?<!…) 负向回顾，避免旧版 iOS Safari 报错 */
const LEGACY_EMOJI_TOKEN_RE = /(?:^|[^[])emoji_\d+(?!\])/g;
/** 解析文本中的 [emoji_0] 等占位符（兼容旧版 emoji_0） */
export function parseEmojiContent(content) {
    if (!content)
        return [];
    const parts = [];
    let lastIndex = 0;
    const re = new RegExp(`${EMOJI_TOKEN_RE.source}|${LEGACY_EMOJI_TOKEN_RE.source}`, 'g');
    let match;
    while ((match = re.exec(content)) !== null) {
        if (match.index > lastIndex) {
            parts.push({ type: 'text', value: content.slice(lastIndex, match.index) });
        }
        const token = match[0];
        const key = extractEmojiKey(token);
        parts.push(getEmojiImageUrl(key)
            ? { type: 'emoji', value: key }
            : { type: 'text', value: token });
        lastIndex = match.index + token.length;
    }
    if (lastIndex < content.length) {
        parts.push({ type: 'text', value: content.slice(lastIndex) });
    }
    return parts.length ? parts : [{ type: 'text', value: content }];
}
/** 发送 TIM 表情消息时 payload.data 使用 emoji_N */
export function toFacePayloadData(data) {
    const text = data.trim();
    if (/^emoji_\d+$/.test(text))
        return text;
    const match = /^(\d+)$/.exec(text);
    if (match)
        return `emoji_${match[1]}`;
    return text;
}
